.messageLink {
  color: var(--link-color);
  transition: color 0.2s ease;
  cursor: pointer;
  text-decoration: none;
}

.messageLink:hover {
  color: var(--link-hover-color);
}
